import { usePunditUserContext } from "@circle-react/contexts";
import {
  isCommunityAdmin,
  isCommunityModerator,
} from "@circle-react/helpers/communityMemberHelpers";

export const useCanUploadMedia = () => {
  const { currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();

  const isBetaFlagEnabled = Boolean(
    currentCommunitySettings?.cms_member_media_upload_enabled,
  );
  const isAdminFlagEnabled = Boolean(
    currentCommunitySettings?.member_media_uploads_enabled,
  );
  const isAdminOrModerator =
    isCommunityAdmin(currentCommunityMember) ||
    isCommunityModerator(currentCommunityMember);

  if (!isBetaFlagEnabled) {
    return true;
  }
  return isAdminOrModerator || isAdminFlagEnabled;
};
